import React from "react";
import { ReCaptchaProvider } from "@wss/re-captcha";
import {
  PageCreatorGroupModel,
  PageCreatorSectionModel,
  PageCreatorSectionType,
} from "../Models/PageCreatorPage";
import OverlappingWrapper, { getBackgroundColor } from "./OverlappingWrapper";
import LeadGenHero from "./LeadGenHero";
import LeadGenContent from "./LeadGenContent";
import LeadGenFeature from "./LeadGenFeature";
import LeadGenForm from "./LeadGenForm";

interface Props {
  pageId: number;
  groups: PageCreatorGroupModel[];
}

export default ({ groups, pageId }: Props) => {
  const displaySection = (section: PageCreatorSectionModel) => {
    switch (section.sectionType) {
      case PageCreatorSectionType.Hero:
        return <LeadGenHero {...section.hero} />;
      case PageCreatorSectionType.Content:
        return <LeadGenContent {...section.content} />;
      case PageCreatorSectionType.Feature:
        return (
          <LeadGenFeature
            sectionStyle={section.sectionStyle}
            {...section.feature}
          />
        );
      case PageCreatorSectionType.Form:
        return (
          <ReCaptchaProvider>
            <LeadGenForm
              {...section.form}
              description={section.description}
              pageId={pageId}
              sectionId={section.sectionId}
            />
          </ReCaptchaProvider>
        );
      default:
        return <></>;
    }
  };

  return (
    <div data-module="initPageCreatorLeadGenerationPage" className="lt:-mt-6">
      {groups.map((group) =>
        group.sections.map((section, index) => {
          return (
            <div
              id={
                section.description
                  ? section.description
                  : (section.sortOrder + 1).toString()
              }
              key={section.sortOrder}
              data-testid={`section-${section.sortOrder}`}
            >
              <OverlappingWrapper
                topBackgroundColor={
                  getBackgroundColor(group.sections[index - 1]) || ""
                }
                bottomBackgroundColor={
                  getBackgroundColor(group.sections[index + 1]) || ""
                }
                section={section}
              >
                {displaySection(section)}
              </OverlappingWrapper>
            </div>
          );
        }),
      )}
    </div>
  );
};
